/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { CardWithUserAvailableMerchantCategoriesInner } from './card-with-user-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { CardWithUserReissue } from './card-with-user-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { CardWithUserUser } from './card-with-user-user';
// May contain unused imports in some cases
// @ts-ignore
import { CardWithUserUserAccountGroup } from './card-with-user-user-account-group';

/**
 * 
 * @export
 * @interface CardWithUser
 */
export interface CardWithUser {
    /**
     * 
     * @type {string}
     * @memberof CardWithUser
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUser
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof CardWithUser
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof CardWithUser
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CardWithUser
     */
    'availableCurrencies': Array<CardWithUserAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<CardWithUserAvailableMerchantCategoriesInner>}
     * @memberof CardWithUser
     */
    'availableMerchantCategories': Array<CardWithUserAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {CardWithUserUser}
     * @memberof CardWithUser
     */
    'user': CardWithUserUser;
    /**
     * 
     * @type {CardWithUserUserAccountGroup}
     * @memberof CardWithUser
     */
    'userAccountGroup'?: CardWithUserUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof CardWithUser
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof CardWithUser
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CardWithUser
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {CardWithUserReissue}
     * @memberof CardWithUser
     */
    'reissue'?: CardWithUserReissue | null;
}

export const CardWithUserAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type CardWithUserAvailableCurrenciesEnum = typeof CardWithUserAvailableCurrenciesEnum[keyof typeof CardWithUserAvailableCurrenciesEnum];


